<script setup>
import { onMounted, ref } from "vue";

defineProps({
    modelValue: {
        type: String,
        default: null,
    },
});

defineEmits(["update:modelValue"]);

const input = ref(null);

onMounted(() => {
    if (input.value.hasAttribute("autofocus")) {
        input.value.focus();
    }
});
</script>

<template>
    <input
        ref="input"
        class="w-full rounded-xl border border-gray-300 px-4 py-3 text-sm text-gray-900 shadow-sm outline-none"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
    />
</template>
